import request from "root/js/request";

export const getCartKillerWidgets = async ({ cabinet_id, date_from, date_to }) => {
  const response = await request({
    url: `/api/analytics/cart_killer_widgets/?cabinet_id=${cabinet_id}`,
    method: "get",
    params: {
      date_from,
      date_to,
    },
  });
  return response.data;
};
